import {createI18n} from 'vue-i18n';

// Import locale messages
import de from './locales/de.json';
import en from './locales/en.json';

const messages = {en,de };

const i18n = createI18n({
    legacy: false, // Enables Composition API usage
    locale: sessionStorage.getItem('lang') || 'de',
    fallbackLocale: 'de',
    messages
});

export default i18n;
